import {EnergieEnum} from '../../pages/rt2012/suivi-des-consommations/enums/EnergieEnum';
import {TypeRepartitionEnum} from './typeRepartitionEnum';
import {TypeChauffageEnum} from './typeChauffageEnum';
import {TypeECSEnum} from './typeECSEnum';
import {TypeProductionEnum} from './typeProductionEnum';
import {deserializeAs} from 'cerialize';

export class ParametrageBatiment {
  @deserializeAs('compteur_collectif_chauffage')
  compteurCollectifChauffage: boolean;
  @deserializeAs('compteur_collectif_ecs')
  compteurCollectifEcs: boolean;
  @deserializeAs('compteurs_individuels_chauffage')
  compteursIndividuelsChauffage: boolean;
  @deserializeAs('compteurs_individuels_ecs')
  compteursIndividuelsEcs: boolean;
  @deserializeAs('connexion_ecs')
  connexionCcs: boolean;
  @deserializeAs(Date, 'date_arret_chauffage')
  dateArretChauffage: Date;
  @deserializeAs(Date, 'date_arret_refroidissement')
  dateArretRefroidissement: Date;
  @deserializeAs(Date, 'date_demarrage_chauffage')
  dateDemarrageChauffage: Date;
  @deserializeAs(Date, 'date_demarrage_refroidissement')
  dateDemarrageRefroidissement: Date;
  @deserializeAs(TypeRepartitionEnum, 'repartition')
  repartition: TypeRepartitionEnum;
  @deserializeAs('resultat_dpechauffage')
  resultatDpechauffage: number;
  @deserializeAs('resultat_dpeecs')
  resultatDpeecs: number;
  @deserializeAs('resultat_dpeprimaire_chauffage')
  resultatDpeprimaireChauffage: number;
  @deserializeAs('resultat_dpeprimaire_ecs')
  resultatDpeprimaireEcs: number;
  @deserializeAs('resultat_dpeprimaire_refroidissement')
  resultatDpeprimaireRefroidissement: number;
  @deserializeAs('resultat_dperefroidissement')
  resultatDperefroidissement: number;
  @deserializeAs('surface')
  surface: number;
  @deserializeAs('type_batiment')
  typeBatiment: string;
  @deserializeAs(TypeChauffageEnum, 'type_chauffage')
  typeChauffage: TypeChauffageEnum;
  @deserializeAs(TypeECSEnum, 'type_ecs')
  typeEcs: TypeECSEnum;
  @deserializeAs(TypeProductionEnum, 'type_production_chauffage')
  typeProductionChauffage: TypeProductionEnum;
  @deserializeAs(TypeProductionEnum, 'type_production_ecs')
  typeProductionEcs: TypeProductionEnum;
  @deserializeAs(TypeProductionEnum, 'type_production_refroidissement')
  typeProductionRefroidissement: TypeProductionEnum;
}
